import getConfig from 'next/config';

const {
  publicRuntimeConfig: { CZEN_GENERAL },
} = getConfig();

export const urlHelper = (url: string | undefined) => {
  return (url && (url.includes(CZEN_GENERAL) ? url : `${CZEN_GENERAL}${url}`)) || undefined;
};
